import {ready} from 'dauphine-js';

ready(() => {
    require('./components/_sliders');
    require('./components/_svg');
    require('./components/_menu');
    require('./components/_scroll');
    require('./components/_search');
    require('./components/_news');
    require('./components/_radio');
    require('./components/_forms');
    require('./components/_map');
});
